/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import { Activity } from '../../types/schedule.types';
import ActivityCard from './ActivityCard';
import styles from '../../styles/Schedule/DayColumn.module.css';
import { VISIBLE_ACTIVITIES_PER_DAY } from '../../constants/activitytypes.constant';

interface DayColumnProps {
	dayLabel: string; // "Mon", "Tues", etc.
	date: Date;
	activities: Activity[];
	isToday: boolean;
	onActivityClick?: (activity: Activity) => void;
}

const DayColumn: React.FC<DayColumnProps> = ({
	dayLabel,
	date,
	activities,
	isToday,
	onActivityClick,
}) => {
	const [expanded, setExpanded] = useState(false);
	const count = activities.length;
	const visible = expanded
		? activities
		: activities.slice(0, VISIBLE_ACTIVITIES_PER_DAY);
	const hiddenCount = count - VISIBLE_ACTIVITIES_PER_DAY;
	return (
		<div
			className={`${styles.column} ${isToday ? styles.columnToday : ''}`}
		>
			{/* Column header */}
			<div className={`${isToday ? styles.headerToday : styles.header}`}>
				<span
					className={`${styles.dayName} ${isToday ? styles.dayNameToday : ''}`}
				>
					{dayLabel}
				</span>
				{count > 0 && <span className={styles.count}>{count}</span>}
			</div>

			{/* Activity cards */}
			<div className={styles.cards}>
				{visible.map(activity => (
					<ActivityCard
						key={activity.id}
						activity={activity}
						onClick={onActivityClick}
					/>
				))}

				{/* Show more / less toggle */}
				{!expanded && hiddenCount > 0 && (
					<button
						className={styles.toggleBtn}
						onClick={() => setExpanded(true)}
						aria-label={`Show ${hiddenCount} more activities`}
					>
						<svg
							width="14"
							height="14"
							viewBox="0 0 14 14"
							fill="none"
						>
							<path
								d="M3 5l4 4 4-4"
								stroke="currentColor"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</button>
				)}

				{expanded && count > VISIBLE_ACTIVITIES_PER_DAY && (
					<button
						className={styles.toggleBtn}
						onClick={() => setExpanded(false)}
						aria-label="Show fewer activities"
					>
						<svg
							width="14"
							height="14"
							viewBox="0 0 14 14"
							fill="none"
						>
							<path
								d="M3 9l4-4 4 4"
								stroke="currentColor"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</button>
				)}
			</div>
		</div>
	);
};

export default DayColumn;
